module.exports = __webpack_public_path__ + "static/media/CoworkSmall3Web.49961d7b.webp";